import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Location } from "../../location/location.model";
import { Rate } from "../rate-type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { RateFlatRoute } from "./rate-flat-route.type";
import { WeightBracketPrices } from "../../shared/weight-bracket/weight-bracket-prices.model";

export class RateLtlRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public comment: string,
    public originLocation: Location,
    public destinationLocation: Location,
    public transitTime: number,
    public serviceDays: number,
    public weightBrackets?: WeightBracketPrices,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getRequestParams() {
    return {
      comment: this.comment,
      originLocation: this.originLocation.getId(),
      destinationLocation: this.destinationLocation.getId(),
      weightBrackets: this.weightBrackets.getRequestParams(),
      transitTime: this.transitTime,
      serviceDays: this.serviceDays,
    };
  }

  public isValid(): boolean {
    return !!this.originLocation && !!this.destinationLocation;
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      comment: this.comment,
      originLocation: LocationMapper.map(this.originLocation),
      destinationLocation: LocationMapper.map(this.destinationLocation),
      weightBrackets: this.weightBrackets.getRequestParams(),
      transitTime: this.transitTime,
      serviceDays: this.serviceDays,
    });
  }
}
